import { apiClient } from '@/lib/api/api-client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type {
  AnalyticsData,
  AnalyticsPeriod,
  MarginsData,
  WinLossData,
  DiscountDepthData,
  ModelEffectivenessEntry,
  TrendEntry,
  PriceWaterfallData,
} from '../types/analytics.types';

export const analyticsService = {
  getOverview: (period: AnalyticsPeriod = '30d', lobId?: string, userId?: string) => {
    const params = new URLSearchParams({ period });
    if (lobId) params.set('lobId', lobId);
    if (userId) params.set('userId', userId);
    return apiClient.get<AnalyticsData>(`${ENDPOINTS.ANALYTICS_OVERVIEW}?${params.toString()}`);
  },

  getMargins: async (
    period?: AnalyticsPeriod,
    lobId?: string,
    sellerId?: string
  ): Promise<MarginsData> => {
    const params: Record<string, string> = {};
    if (period) params.period = period;
    if (lobId) params.lobId = lobId;
    if (sellerId) params.sellerId = sellerId;
    return apiClient.get(ENDPOINTS.ANALYTICS_MARGINS, { params });
  },

  getWinLoss: async (period?: AnalyticsPeriod): Promise<WinLossData> => {
    const params: Record<string, string> = {};
    if (period) params.period = period;
    return apiClient.get(ENDPOINTS.ANALYTICS_WIN_LOSS, { params });
  },

  getDiscountDepth: async (period?: AnalyticsPeriod): Promise<DiscountDepthData> => {
    const params: Record<string, string> = {};
    if (period) params.period = period;
    return apiClient.get(ENDPOINTS.ANALYTICS_DISCOUNT_DEPTH, { params });
  },

  getModelEffectiveness: async (): Promise<ModelEffectivenessEntry[]> => {
    return apiClient.get(ENDPOINTS.ANALYTICS_MODEL_EFFECTIVENESS);
  },

  getTrends: async (months?: number): Promise<TrendEntry[]> => {
    const params: Record<string, string> = {};
    if (months) params.months = String(months);
    return apiClient.get(ENDPOINTS.ANALYTICS_TRENDS, { params });
  },

  getPriceWaterfall: async (period?: AnalyticsPeriod): Promise<PriceWaterfallData> => {
    const params: Record<string, string> = {};
    if (period) params.period = period;
    return apiClient.get(ENDPOINTS.ANALYTICS_PRICE_WATERFALL, { params });
  },
};
